export enum AgeSegmentRoomState {
    ADULT = 'ADULT',
    CHILD = 'CHILD',
    BABY = 'BABY',
}

export interface CancellationPolicyState {
    id: number;
    text: string;
}

export interface BookingRoomRateState {
    id: string;
    amount: number;
    night: number;
}

export interface BookingRoomGuestState {
    name: string;
    surname: string;
    age: number;
    ageSegment: AgeSegmentRoomState;
}

export interface BookingRoomTaxState {
    id: string;
    name: string;
    description: string;
    amount: number;
    currencyKey: string;
    supplierSupplement: string;
    onlyAdults: boolean;
    onlyChildren: boolean;
    supplierTaxCalculationRuleType: string;
    supplierTaxCalculationRuleTypeKey: string;
    supplierTaxCalculationType: string;
    supplierTaxCalculationTypeKey: string;
}

export interface BookingRoomSupplementState {
    id: string;
    name: string;
    description: string;
    amount: number;
    currencyKey: string;
    supplierSupplement: string;
    onlyAdults: boolean;
    onlyChildren: boolean;
    supplierTaxCalculationRuleType: string;
    supplierTaxCalculationRuleTypeKey: string;
    supplierTaxCalculationType: string;
    supplierTaxCalculationTypeKey: string;
}

export interface BookingRoomState {
    id: string;
    roomType: string;
    roomMappingCode: string;
    mealPlan: string;
    mealPlanMappingCode: string;
    ratePlan: string;
    ratePlanMappingCode: string;
    guests: BookingRoomGuestState[];
    prices: BookingRoomRateState[];
    taxes: BookingRoomTaxState[];
    supplements: BookingRoomSupplementState[];
}

export type BookingHotelImageState = {
    id: string;
    caption: string;
    published: boolean;
    feature: boolean;
    virtualPath: string;
} | null;

export interface BookingState {
    status: string;
    statusColor: string;
    isCancelled: boolean;
    hotel: string;
    idHotel: string;
    address: string;
    hotelRating: number;
    hotelCategory: string;
    bookingCode: string;
    hotelRefecerenceCode: string;
    checkIn: Date | null;
    checkOut: Date | null;
    bookingDate: Date | null;
    nights: number;
    customerName: string;
    paxes: number;
    totalAmount: number;
    paymentId: number;
    currency: string;
    cancellationPolicies: CancellationPolicyState[];
    rooms: BookingRoomState[];
    hotelImages: BookingHotelImageState[];
    notes: string;
    paymentAmount: number;
    paymentCurrency: string;
}

export interface CreditCardState {
    creditCardHolderName: string;
    creditCardNumber: string;
    creditCardExpiryDate: string;
    cvc: string;
}
